<template>
  <div class="sd-single-view">
    <div class="sd-scrollable-div"  v-if="result.length">
      <div class="sd-content-card">
        <jira-card
          v-if="this.$route.meta.jira || this.$route.meta.token"
          :displayMethod="'single-ticket'"
          :preloadedResult="result"
          :preloadedComments="commentsResults"
        />
        <confluence-card
          v-if="this.$route.meta.confluence"
          :preloadedResult="result"
        />
      </div>
    </div>

    <loader-animation
      :loader="loader"
      :isResults="result.length"
      :errorMessage="errorMsg"
    />

  </div>
</template>

<script>
import mixin from './mixins/Mixins';
import JiraCard from './childs/JiraCard';
import ConfluenceCard from './childs/ConfluenceCard';
import LoaderAnimation from '../components/LoaderAnimation';

export default {
  name: 'single-vue',
  mixins: [mixin],
  components: {
    JiraCard,
    ConfluenceCard,
    LoaderAnimation,
  },

  data() {
    return {
      routeKey: null,
      errorMsg: false,
      loader: true,
      result: [],
      commentsJira: null,
      commentsResults: null,
      pageId: null,
    };
  },

  watch: {
    pageId(newVal) {
      if (/^\d+$/.test(newVal)) {
        this.queryCql();
      }
    },
  },

  mounted() {
    if (this.$route.meta.confluence) {
      // Mounted Hook for Confluence single View
      this.identifier = this.$route.params.identifier;
      this.routeKey = this.$route.params.key;
      const isId = (/^\d+$/.test(this.identifier));
      if (!isId) {
        const params = {
          portal: this.routeKey,
        };

        const url = `/app/get_conf_id/${this.identifier}`;
        axios.get(url, {
          headers: {
            Pragma: 'no-cache',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
          },
          params,
        }).then((response) => {
          this.pageId = response.data;
        }).catch((error) => {
          if (error.response.data.message) {
            this.$router.push(`/?path=${window.location.href}`);
          } else {
            this.errorMsg = 'Falsche Anfrage';
          }
        });
      } else {
        this.pageId = this.identifier;
      }
    } else if (this.$route.meta.jira) {
      // Mounted Hook for jira single View
      const issueKey = this.$route.params.issuekey;
      const url = this.routeKey ?
        `/app/single_ticket/${this.routeKey}/${issueKey}` :
        `/app/single_ticket/${issueKey}`;

      axios.get(url, {
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        this.result = response.data[0].issues;
        this.loader = false;
        if (response.data[1].total) {
          this.commentsJira = true;
        }
        this.commentsResults = response.data[1].comments;
      }).catch((error) => {
        if (error.response.data.message) {
          this.errorMsg = error.response.data.message;
        } else {
          this.errorMsg = 'Falsche Anfrage';
        }
      });
    } else if (this.$route.meta.token) {
      // Query jira ticket based on the ticket's AuthenticationToken
      const url = `/app/single_ticket_token/${this.$route.params.token}`;
      axios.get(url, {
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
        },
      }).then((reponse) => {
        this.result = reponse.data[0].issues;
        this.loader = false;
        if (reponse.data[1].total) {
          this.commentsJira = true;
        }
        this.commentsResults = reponse.data[1].comments;
      }).catch((error) => {
        if (error.response.data.message) {
          this.errorMsg = error.response.data.message;
        } else {
          this.errorMsg = 'Falsche Anfrage';
        }
      });
    }
  },

  methods: {
    queryCql() {
      const url = this.routeKey ?
        `/app/single_page/${this.routeKey}/${this.pageId}` :
        `/app/single_page/${this.pageId}`;
      axios.get(url, {
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        this.result = [response.data];
        this.loader = false;
      }).catch((error) => {

        if (!this.$store.state.user.userName) {
          self.logout();
          return;
        }

        if (error.response.data.message) {
          this.$router.push(`/?path=${window.location.href}`);
        } else {
          this.errorMsg = 'Falsche Anfrage';
        }
      });
    },
    logout() {
      // this is a direct copy from Header.vue to fix ALTLBASIS-1932
      const isRouteKey = this.routeKey;
      const isissueKey = this.issueKey;
      const isidentifier = this.identifier;
      const self = this;
      axios({
        method: 'post',
        url: '/app/logout',
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
        },
      }).then(() => {
        if (isRouteKey && typeof isRouteKey !== 'undefined') {
          self.$router.push(`/${isRouteKey}/login`);
        } else if (isissueKey && typeof isissueKey !== 'undefined') {
          self.$router.push(`/login/1/${isissueKey}`);
        } else if (isidentifier && typeof isidentifier !== 'undefined') {
          self.$router.push(`/login/2/${isidentifier}`);
        }
      }).catch((error) => {
        this.logError(error);
      });
    },
  },
};
</script>

<style lang="scss">
.sd-single-view {
  height: 100vh;
  position: relative;

  .sd-content-card {
    margin: 25px 0 25px 0;
  }
}

@media (max-width: 1100px) {
  .sd-single-view {
    font-size: 13px;
  }
}

@media (max-width: 720px) {
  .sd-single-view {
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// SingleView.vue?2ead872c